/**
 * ---------------------------------------------------
 *  CATEGORIAS DA INSTITUIÇÃO
 * ---------------------------------------------------
 */
export const LIST_CATEGORIES_REQUEST = '@institutions/LIST_CATEGORIES_REQUEST';
export const LIST_CATEGORIES_SUCCESS = '@institutions/LIST_CATEGORIES_SUCCESS';
export const LIST_CATEGORIES_FAILURE = '@institutions/LIST_CATEGORIES_FAILURE';

/**
 * ---------------------------------------------------
 *  CADASTRO DE INSTITUIÇÃO
 * ---------------------------------------------------
 */
export const NEW_INSTITUTION_REQUEST = '@institutions/NEW_INSTITUTION_REQUEST';
export const NEW_INSTITUTION_SUCCESS = '@institutions/NEW_INSTITUTION_SUCCESS';
export const NEW_INSTITUTION_FAILURE = '@institutions/NEW_INSTITUTION_FAILURE';

/**
 * ---------------------------------------------------
 *  LOGO DA INSTITUIÇÃO
 * ---------------------------------------------------
 */
export const LOGO_INSTITUTION_REQUEST =
  '@institutions/LOGO_INSTITUTION_REQUEST';
export const LOGO_INSTITUTION_SUCCESS =
  '@institutions/LOGO_INSTITUTION_SUCCESS';
export const LOGO_INSTITUTION_FAILURE =
  '@institutions/LOGO_INSTITUTION_FAILURE';

/**
 * ---------------------------------------------------
 *  GET INSTITUIÇÃO
 * ---------------------------------------------------
 */
export const GET_INSTITUTION_REQUEST = '@institutions/GET_INSTITUTION_REQUEST';
export const GET_INSTITUTION_SUCCESS = '@institutions/GET_INSTITUTION_SUCCESS';
export const GET_INSTITUTION_FAILURE = '@institutions/GET_INSTITUTION_FAILURE';

/**
 * ---------------------------------------------------
 *  GET INSTITUIÇÕES PARTICIPANTES
 * ---------------------------------------------------
 */
export const GET_INSTITUTIONS_REQUEST =
  '@institutions/GET_INSTITUTIONS_REQUEST';
export const GET_INSTITUTIONS_SUCCESS =
  '@institutions/GET_INSTITUTIONS_SUCCESS';
export const GET_INSTITUTIONS_FAILURE =
  '@institutions/GET_INSTITUTIONS_FAILURE';

/**
 * ---------------------------------------------------
 *  OPCOES PERFIL HOSPITALAR
 * ---------------------------------------------------
 */

export const OPCOES_PERFIL_SUCCESS = '@institutions/OPCOES_PERFIL_SUCCESS';
export const OPCOES_PERFIL_FAILURE = '@institutions/GET_INSTITUTIONS_FAILURE';
